import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { Box, IconButton, Typography } from '@mui/material';
import { FC } from 'react';
import { DpButton } from '@/components/blocks/DpLibrary/DpButton';
import {
	DpFanFinishCouponButtonFrameSx,
	DpFanFinishCouponButtonSx,
	DpFanFinishCouponCodeFrameSx,
	DpFanFinishCouponCodeLabelSx,
	DpFanFinishCouponCodeSx,
	DpFanFinishCouponCodeTitleSx,
	DpFanFinishCouponCodeWrapperSx,
	DpFanFinishCouponCopySx,
	DpFanFinishCouponDataSx,
	DpFanFinishCouponDisclaimerSx,
	DpFanFinishCouponFrameSx,
	DpFanFinishCouponMessageSx,
	DpFanFinishCouponTitleSx,
} from '@/components/blocks/DpFanFinishCoupon/style';
import {
	DpFanFinishStageContentSx,
	DpFanFinishStageDataImageSx,
	DpFanFinishStageDataSx,
} from '@/components/blocks/DpFanDialog/parts/DpFanFinishStage/style';
import { Img } from '@/components/blocks/MaterialImage';
import { useNotifications } from '@/data/Content/Notifications';

interface DpFanFinishCouponProps {
	title?: string;
	message?: string;
	code?: string;
	href?: string;
	disclaimer?: string;
	buttonText?: string;
}

export const DpFanFinishCoupon: FC<DpFanFinishCouponProps> = ({
	title = '',
	message = '',
	code = '',
	href = '/',
	disclaimer = 'Este cupón no aplica en productos con descuento ni en artículos del mundial.',
	buttonText = 'Aceptar',
}) => {
	const { showSnackbarMessage } = useNotifications();
	const handleCopyCode = () => {
		if (code) {
			navigator.clipboard.writeText(code);
			showSnackbarMessage('¡Código copiado!');
		}
	};

	return (
		<Box sx={DpFanFinishStageContentSx}>
			<Box sx={DpFanFinishStageDataSx}>
				<Img src="/images/dpfan/dpfan_finish.png" alt="wand-big" sx={DpFanFinishStageDataImageSx} />
			</Box>
			<Box sx={DpFanFinishCouponFrameSx}>
				<Box sx={DpFanFinishCouponDataSx}>
					{title ? <Typography sx={DpFanFinishCouponTitleSx}>{title}</Typography> : null}
					{message ? <Typography sx={DpFanFinishCouponMessageSx}>{message}</Typography> : null}
				</Box>
				{code ? (
					<Box sx={DpFanFinishCouponCodeWrapperSx}>
						<Box sx={DpFanFinishCouponCodeFrameSx}>
							<Box sx={DpFanFinishCouponCodeLabelSx}>
								<Typography sx={DpFanFinishCouponCodeTitleSx}>{'CÓDIGO DE DESCUENTO:'}</Typography>
								<Typography sx={DpFanFinishCouponCodeSx}>{code}</Typography>
							</Box>
							<IconButton
								aria-label="Copiar código de descuento"
								onClick={handleCopyCode}
								sx={DpFanFinishCouponCopySx}
							>
								<ContentCopyIcon fontSize="inherit" />
							</IconButton>
						</Box>
						{disclaimer ? (
							<Typography sx={DpFanFinishCouponDisclaimerSx}>{disclaimer}</Typography>
						) : null}
					</Box>
				) : null}
				<Box sx={DpFanFinishCouponButtonFrameSx}>
					<DpButton href={href} variant="primary" fullWidth sx={DpFanFinishCouponButtonSx}>
						{buttonText}
					</DpButton>
				</Box>
			</Box>
		</Box>
	);
};
